import type { ItemLevel } from '../types/userLevel.type';

export const APPROVER_USER_LEVEL = 3;

export const ADMIN_USER_LEVEL = 4;

export const EXTERNAL_USER_LEVEL = 5;

export const listLevel: ItemLevel[] = [
  {
    name: 'Observador',
    level: 1,
    permissions: [
      'Visualizar saldos y movimientos de cuenta',
      'Descargar documentos entre ellos extractos/cartolas y certificados de cuenta',
    ]
  },
  {
    name: 'Creador',
    level: 2,
    description: 'Todo lo que <strong>incluye el Nivel 1</strong>, además:',
    permissions: [
      'Crear transacciones únicas o múltiples para su aprobación',
      'Cancelar transacciones únicas o múltiples',
      'Crear, editar y eliminar contactos',
      'Cargar dinero a la cuenta',
    ],
    summary: `El <strong>Nivel Creador</strong>, incluye todos los permisos del <strong>Nivel 1</strong>`,
  },
  {
    name: 'Aprobador',
    level: 3,
    description: 'Todo lo que <strong>incluye el Nivel 1 y 2,</strong> además:',
    permissions: [
      'Aprobar y rechazar transacciones',
      'Realizar conversiones de divisas',
    ],
    summary: 'El Nivel Aprobador, incluye todos los permisos de los Niveles 1 y 2.'
  },
  {
    name: 'Administrador',
    level: 4,
    description: 'Todo lo que <strong>incluye el Nivel 1, 2 y 3</strong>, además:',
    permissions: [
      'Invitar a nuevos usuarios',
      'Administración de usuarios: cambiar el rol, eliminar y ver historial de actividad',
      'Visualizar datos de la tarjeta',
      'Bloquear y desbloquear tarjeta',
      'Renovar una tarjeta',
      'Crear y eliminar cuentas en otras monedas',
    ],
    summary: 'El <strong>Nivel Administrador</strong>, incluye todos los permisos de los <strong>Niveles 1, 2 y 3</strong>.',
  }
];
